import { useCallback, useState } from 'react';

import { scrollRootToTop } from '@/core/utils/ui';
import { scrollEvent } from '@/features/rapidstor/PostMessageEvents';

import type { SpaceCalculatorResult } from './calculator';

export default function useSpaceCalculator(onResult: (result: SpaceCalculatorResult) => void) {
    const [isOpen, setIsOpen] = useState(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    /** Submitting with nothing entered just closes, leaving the listing filter as it was. */
    const finish = useCallback((result: SpaceCalculatorResult | null) => {
        setIsOpen(false);
        scrollRootToTop();
        scrollEvent();
        if (result) {
            onResult(result);
        }
    }, [onResult]);

    return {
        isOpen,
        open,
        close,
        finish,
    };
}
